import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { useRecoilValue } from "recoil";
import { tenantState } from "../recoil/tenant/atoms";
import paymentApi from "../../common/api/paymentApi";
import { PaymentSetTypes } from "../../common/types/PaymentSetTypes";

export const getAllPaymentSet = createAsyncThunk(
    "/paymentset",
    async (params: any,{ rejectWithValue }) => {
        try {
            const method = "/paymentset";
            const { data, errorMessage, isSuccess } = await paymentApi.get(method, params.parameters, params.apiParams);

            if (isSuccess) {
                data.sort((a: any, b: any) => b.paymentSetId - a.paymentSetId);
                return data;
            } else {
                return rejectWithValue(data);
            }
        } catch (error: any) {
          console.error("Hata yakalandı:", error);

          // Hata nesnesinde `data` veya `message` varsa kontrol et
          const errorMessage =
              error?.data?.message || error?.message || "Bilinmeyen bir hata oluştu";
      
          return rejectWithValue(errorMessage);
        }
    }
)

export interface paymentSetStateType extends FetchResultType {
    paymentSetList: PaymentSetTypes;
}

export const paymentSetSlice = createSlice({
    name: "paymentSetList",
    initialState: {
        paymentSetList: [],
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        isFetchComplete: false
      },
      reducers: {
        clearState: (state) => {
          state.paymentSetList = [];
          state.isFetching = false;
          state.isSuccess = false;
          state.isError = false;
          state.isFetchComplete = false;
          return state;
        },
      },
      extraReducers: (builder) => {
        builder.addCase(getAllPaymentSet.fulfilled, (state, { payload }) => {
          state.paymentSetList = payload;
          state.isFetching = false;
          state.isSuccess = true;
          state.isError = false; 
          state.isFetchComplete = true;
          return state;
        });
        builder.addCase(getAllPaymentSet.rejected, (state, { payload }) => {
          state.isFetching = false;
          state.isError = true; 
          // state.errorMessage = payload.message;
        });
        builder.addCase(getAllPaymentSet.pending, (state) => {
          state.isFetching = true;
        });
      },
});
export const { clearState } = paymentSetSlice.actions;

export const paymentSetSelector = (state: any) => state.paymentSetList;

export const paymentSetReducer = paymentSetSlice.reducer;
